@if (isVisible && activeSession; as session) {
<div class="floating-actions" role="group" aria-label="Actions rapides du saloon en cours">
  <button type="button" class="action-button" (click)="openMySaloon()">
    <span class="icon-wrap" aria-hidden="true">
      <svg viewBox="0 0 24 24" fill="none">
        <path
          d="M12 21s-6-4.35-6-10a6 6 0 1 1 12 0c0 5.65-6 10-6 10Z"
          stroke="currentColor"
          stroke-width="1.85"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <circle cx="12" cy="11" r="2.4" fill="currentColor" />
      </svg>
    </span>
    <span class="label">Mon saloon</span>
  </button>

  <span class="divider" aria-hidden="true"></span>

  <button type="button" class="action-button" (click)="openSaloonChat()">
    <span class="icon-wrap" aria-hidden="true">
      <svg viewBox="0 0 24 24" fill="none">
        <path
          d="M7 18.5c-1.8 0-3-1.2-3-3V8.5c0-1.8 1.2-3 3-3h10c1.8 0 3 1.2 3 3v7c0 1.8-1.2 3-3 3H12l-4.5 3v-3H7Z"
          stroke="currentColor"
          stroke-width="1.85"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </span>
    <span class="label">Chat</span>
  </button>
</div>
}
